import ShipmentSummary from "./ShipmentSummary";

export default ShipmentSummary;
